// src/AppRoutes.js
import { Routes, Route } from "react-router-dom";
import Login from "./component/Login";
import Home from "./component/Home";
import LogPage from "./component/LogPage";

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/log" element={<LogPage />} />
        </Routes>
    );
}

export default AppRoutes;
